<template>
  <div class="dispatch-center">
    <div class="po-center">
      <div class="top mt-100 flex align-items">
        <div
          v-for="(item, index) in target"
          :key="'target' + index"
          class="flex item align-items justify-content-center"
        >
          <img
            class="img"
            style="width: 30%; height: auto"
            :src="
              require(`@/assets/images/computility/overview-top-${
                index + 1
              }.png`)
            "
            alt=""
          />
          <div class="item-r flex flex-direction ml-20">
            <!-- align-items-flex-start  添加左对齐-->
            <!-- <div class="num" >{{ Number(item.number).toFixed(0) }}</div> -->
            <animate-number
              class="num"
              :style="{ color: item.color }"
              from="0"
              :to="Number(item.number)"
              :key="Number(item.number)"
              duration="2000"
            ></animate-number>
            <div class="label" style="color: #fff; font-size: 30px">
              {{ item.label }}
            </div>
          </div>
        </div>
      </div>
      <div class="middle mt-100">
        <!-- <div class="flex flex-wrap boxItem align-content justify-content" style="height:600px">
                        <div 
                        v-for="(item,index) in target" :key="'target'+ index"
                        class="target item align-items justify-content-center">
                            <img class="img" :src="require(`@/assets/images/computility/dispatch-icon-${index+1}.png`)" alt="">
                            <div class="item-r flex-direction">
                                <div class="num" style="color:#fff;font-size:50px">{{ item.number }}</div>
                                <div class="label">{{ item.label }}</div>
                            </div>
                        </div>
                    </div> -->
        <div class="centerRound">
          <div class="Totaltop-up mt-200">
            <div class="count">
              {{ addCommas(Number(total).toFixed(0)) }}<span>卡时</span>
            </div>
            <div class="label mt_50">总充值</div>
          </div>
        </div>

        <div class="bigRound">
          <div class="Totaltop-up1 mt-50">
            <div class="count mt-20">
              {{ list[1].load }}<span class="unid">%</span>
            </div>
            <div class="label mt_10">CPU</div>
          </div>
        </div>

        <div class="smallRound">
          <div class="Totaltop-up1">
            <div class="count mt-20">
              {{ list[0].load }}<span class="unid">%</span>
            </div>
            <div class="label mt_20">GPU</div>
          </div>
        </div>

        <div class="smallRound1 mt-50">
            <div class="Totaltop-up1">
            <div class="count mt-20">
              {{ list[2].load }}<span class="unid">%</span>
            </div>
            <div class="label mt_20">内存</div>
          </div>
        </div>
        <div class="centerBody"></div>
      </div>
      <div class="bottom mt-50">
        <Part7 />
      </div>
    </div>
  </div>
</template>

<script>
import Part7 from "./../../components/overviewCom/part-7.vue";
import { dataInterface } from "@/api/dataInterfaceApi";
export default {
  components: {
    Part7,
  },
  data() {
    return {
      target: [
        {
          number: "",
          label: "总订单数",
        },
        {
          number: "",
          label: "总客户数量",
        },
        {
          number: "",
          label: "总消耗(卡时)",
        },
        {
          number: "",
          label: "待消耗(卡时)",
        },
      ],
      total: "",
      list: [],
    };
  },
  mounted() {
    this.getbatteryCharging();
    this.getbatteryCharging1();
  },
  methods: {
    // 预览汇总
    getbatteryCharging() {
      let params = {
        enCode: "computingpower-mid-ylhz",
      };
      dataInterface.dataFaceApi(params).then((res) => {
        console.log(res, "预览汇总");
        if (!res) return;
        this.target[0].number = res[0].order_total || "-";
        this.target[1].number = res[0].user_total || "-";
        this.target[2].number = res[0].usetime_total || "-";
        this.target[3].number = res[0].unusetime_total || "-";
        this.total = res[0].time_total || "-";
      });
    },
    addCommas(number) {
      const parts = number.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts.join(".");
    },
    // 实时负载
    getbatteryCharging1() {
			let params = { 
				enCode: 'computingpower-right-ssfz',
			}
            let data = []
			dataInterface.dataFaceApi(params).then(res => {
				console.log(res, '实时负载1111')
                
                this.list = res || []
			})
            console.log(this.list, '实时负载2222')
        }
  },
};
</script>

<style lang="scss" scoped>
@import "../../components/comm.scss";
.num {
  color: #fff;
  font-size: $FontSize60;
  @include ffamily-DS;
}

.dispatch-center {
  width: 100%;
  height: 100%;
  background: url(~@/assets/images/computility/overview-bg.png) no-repeat;
  background-size: 100% 100%;
  .po-center {
    width: 1800px;
    height: 1800px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    // background: red;
    .top {
      width: 100%;
      height: 200px;
      // background: orange;
    }
    .middle {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -70%);
      width: 2816px;
      height: 1440px;
      .centerRound {
        position: absolute;
        top: 27%;
        left: 40%;
        transform: translate(-50%, -50%);
        width: 550px;
        height: 550px;
        background: url(~@/assets/images/computility/centerRound.png) no-repeat
          center center;
        background-size: 100% 100%;
        animation: Beating1 2.2s linear infinite;
        z-index: 10;
      }
      .bigRound {
        position: absolute;
        top: 51%;
        left: 27%;
        // transform: translate(-50%, -50%) ,rotate3d(100,10);
        width: 210px;
        height: 210px;
        background: url(~@/assets/images/computility/bigRound.png) no-repeat
          center center;
        background-size: 100% 100%;
        animation: Beating1 2.2s linear infinite;
        z-index: 10;
      }

      .smallRound {
        position: absolute;
        top: 51%;
        left: 59%;
        transform: translate(-50%, -50%);
        width: 177px;
        height: 177px;
        background: url(~@/assets/images/computility/smallRound.png) no-repeat
          center center;
        background-size: 100% 100%;
        animation: Beating1 2.2s linear infinite;
        z-index: 10;
      }
      .smallRound1 {
        position: absolute;
        top: 54%;
        left: 66%;
        transform: translate(-50%, -50%);
        width: 177px;
        height: 177px;
        background: url(~@/assets/images/computility/smallRound.png) no-repeat
          center center;
        background-size: 100% 100%;
        animation: Beating1 2.2s linear infinite;
        z-index: 10;
      }
      .centerBody {
        position: absolute;
        left: 50%;
        transform: translate(-50%, 50%);
        width: 100%;
        height: 900px;
        background: url(~@/assets/images/computility/centerBody-2.png) no-repeat
          center center;
        background-size: 100% 100%;
        animation: breath_light 5s ease infinite;
      }
      
      // background: green;
      .Totaltop-up {
        .count {
          @include ffamily-DS;
          font-size: $FontSize120;
          span {
            font-size: $FontSize24;
          }
        }
        .label {
          font-size: $FontSize76;
        }
      }

      .Totaltop-up1,.Totaltop-up2{
        .unid{
            font-size: $FontSize36;
        }
      }
      .Totaltop-up1 {
        .count {
          @include ffamily-DS;
          font-size: $FontSize50;
        }
        .label {
          font-size: $FontSize40;
        }
      }
      .Totaltop-up2 {
        .count {
          @include ffamily-DS;
          font-size: $FontSize40;
        }
        .label {
          font-size: $FontSize28;
        }
      }
    }
    .bottom {
      position: absolute;
      top: 1100px;
      width: 100%;
      height: 650px;
      // background:pink;
    }
  }
}

@keyframes diffuse {
  0% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
  100% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(5);
  }
}

.item {
  width: 800px;
}

@keyframes Beating1 {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(60px);
  }
  100% {
    transform: translateY(0);
  }
}
.img {
  animation: breath_light 3s ease infinite;
}
</style>